import { FC } from 'react'
import { Icon } from '@chakra-ui/react'

import { uniqueId } from '@/services'

export const Jpeg: FC = () => {
  const id = `clip${uniqueId()}`
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3171_3582)">
        <path
          d="M43.75 2.1875V19.6875H61.25"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M61.25 28.4375V19.6875L43.75 2.1875H8.75V28.4375"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.75 59.0625V67.8125H61.25V59.0625"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M17.0625 54.25C16.4063 54.25 15.9688 54.25 15.3125 54.0313V51.4063C15.5312 51.4063 15.75 51.4063 15.9688 51.625C16.1875 51.8438 16.4063 51.625 16.625 51.625C17.2813 51.625 17.5 51.4063 17.7188 51.1875C17.9375 50.9688 18.1563 50.3125 18.1563 49.4375V37.8438H21.6562V49.2188C21.6562 50.9688 21.2187 52.2812 20.5625 53.1562C19.9062 54.0312 18.375 54.25 17.0625 54.25Z"
          fill="white"
        />
        <path
          d="M33.2502 41.7813C33.2502 43.0938 32.8127 44.1875 31.9377 45.0625C31.0627 45.9375 29.969 46.1563 28.4377 46.1563H27.5627V50.3125H24.2815V37.8438H28.6565C30.1877 37.8438 31.5002 38.2812 32.1565 38.9375C32.8127 39.5938 33.2502 40.4688 33.2502 41.7813ZM27.5627 43.3125H28.219C28.6565 43.3125 29.094 43.0938 29.5315 42.875C29.969 42.6563 29.969 42.2188 29.969 41.7813C29.969 40.9063 29.5315 40.4688 28.6565 40.4688H27.7815V43.3125H27.5627Z"
          fill="white"
        />
        <path
          d="M50.0937 43.0938H55.5625V49.875C54.0312 50.3125 52.5 50.5312 50.75 50.5312C48.7813 50.5312 47.25 49.875 46.375 48.7812C45.5 47.6875 44.8438 46.1562 44.8438 43.9688C44.8438 42 45.5 40.4687 46.5937 39.1562C47.6875 37.8437 49.4375 37.4062 51.4062 37.4062C52.2812 37.4062 52.9375 37.4063 53.5938 37.625C54.25 37.8438 54.9062 38.0625 55.3437 38.2812L54.25 40.9063C53.375 40.4688 52.2812 40.25 51.1875 40.25C50.0937 40.25 49.4375 40.4687 49 41.125C48.5625 41.7812 48.125 42.875 48.125 44.1875C48.125 45.2813 48.3437 46.1562 48.7812 46.8125C49.2187 47.4687 49.875 47.6875 50.9687 47.6875C51.4062 47.6875 51.8437 47.6875 52.2812 47.4688V45.5H50.0937V43.0938Z"
          fill="white"
        />
        <path
          d="M42.4375 50.3125H35V37.8438H42.4375V40.4688H38.5V42.4375H42.2187V45.0625H38.5V47.4688H42.4375V50.3125Z"
          fill="white"
        />
        <path
          d="M67.8125 28.4375H2.1875V59.0625H67.8125V28.4375Z"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="70px" height="70px" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
